module.exports = __webpack_public_path__ + "static/media/alone-woman.f82aad4e.svg";